import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-down': {
    paths: [
      {
        d: 'M24 34.17L44.59 13.6a2 2 0 012.82 2.82l-22 22a2 2 0 01-2.82 0l-22-22A2 2 0 113.4 13.6L24 34.17z'
      }
    ],
    width: '48',
    height: '48'
  }
})
